export const promotionLinks = {
  telegram: "https://t.me/yumiapp",
};
